import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Routes, Route, Link, useLocation, useNavigate, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Login from "./scene/Login";
import Register from "./scene/Register";
import Home from "./scene/Home";
import GeneralHome from "./scene/GeneralHome";
import Profile from "./scene/Profile";
import Control from "./scene/Control";
import BoardUser from "./scene/Settings";
import BoardModerator from "./scene/BoardModerator";
import BoardAdmin from "./scene/BoardAdmin";
import AlexaPrivacyPolicy from "./scene/AlexaPrivacyPolicy";
import { logout } from "./actions/auth";
import { clearMessage } from "./actions/message";
// import AuthVerify from "./common/AuthVerify";
import EventBus from "./common/EventBus";

const App = () => {
  const currentMainThemeColor = localStorage.getItem("currentMainThemeColor") ?? "#135c13";
  const currentSecondaryThemeColor = localStorage.getItem("currentSecondaryThemeColor") ?? "#cfcfcf";

  document.documentElement.style.setProperty("--main-theme-color", currentMainThemeColor);
  document.documentElement.style.setProperty("--secondary-theme-color", currentSecondaryThemeColor);

  const styles = {
    navItem:{
      color: 'black',
      cursor: 'pointer',
    }
  }

  const [showModeratorBoard, setShowModeratorBoard] = useState(false);
  const [showAdminBoard, setShowAdminBoard] = useState(false);

  const { user: currentUser } = useSelector((state) => state.auth);
  let navigate = useNavigate();
  const dispatch = useDispatch();

  let location = useLocation();

  useEffect(() => {
    if (["/login", "/register"].includes(location.pathname)) {
      dispatch(clearMessage()); // clear message when changing location
    }
  }, [dispatch, location]);

  const logOut = useCallback(() => {
    dispatch(logout(currentUser, navigate));
  }, [dispatch]);

  useEffect(() => {
    if (currentUser) {
      //setShowModeratorBoard(currentUser.roles.includes("ROLE_MODERATOR"));
      setShowAdminBoard(currentUser.user.isAdmin);
      setShowModeratorBoard(false);
    } else {
      setShowModeratorBoard(false);
      setShowAdminBoard(false);
    }

    EventBus.on("logout", () => {
      logOut();
    });

    return () => {
      EventBus.remove("logout");
    };
  }, [currentUser, logOut]);

  return (
    <div>
      <nav className="custom-navbar">
        <Link to={"/GeneralHome"} className="navbar-brand" style={styles.navItem}>
          LandLord Automations
        </Link>
        <div className="navbar-nav mr-auto">
          
          {currentUser && (<li className="nav-item">
            <Link to={"/home"} className="nav-link" style={styles.navItem}>
              Home
            </Link>
          </li>)}
           {currentUser && (<li className="nav-item">
            <Link to={"/profile"} className="nav-link" style={styles.navItem}>
              Profile
            </Link>
          </li>)}

          {currentUser && (
            
            <li className="nav-item">
              <Link to={"/settings"} className="nav-link" style={styles.navItem}>
                Settings
              </Link>
            </li>
          )}

          {currentUser && (
            <li className="nav-item">
              <Link to={"/control"} className="nav-link" style={styles.navItem}>
                Controls
              </Link>
            </li>
          )}

          {showModeratorBoard && currentUser && (
            <li className="nav-item">
              <Link to={"/mod"} className="nav-link" style={styles.navItem}>
                Moderator Board
              </Link>
            </li>
          )}

          {showAdminBoard && currentUser && (
            <li className="nav-item">
              <Link to={"/admin"} className="nav-link" style={styles.navItem}>
                Admin Board
              </Link>
            </li>
          )}
        </div>

        {currentUser ? (
          <div className="navbar-nav ml-auto">
            <li className="nav-item">
              <Link to={"/profile"} className="nav-link" style={styles.navItem}>
                {currentUser.username}
              </Link>
            </li>
            <li className="nav-item"  style={styles.navItem}>
              <a className="nav-link" onClick={logOut} style={styles.navItem}>
                LogOut
              </a>
            </li>
          </div>
        ) : (
          <div className="navbar-nav ml-auto">
            <li className="nav-item">
              <Link to={"/login"} className="nav-link" style={styles.navItem}>
                Login
              </Link>
            </li>

            <li className="nav-item">
              <Link to={"/register"} className="nav-link" style={styles.navItem}>
                Sign Up
              </Link>
            </li>
          </div>
        )}
      </nav>

      <div className="container mt-3">
        <Routes>
          <Route path="" element={<Navigate to="/GeneralHome" />} />
          <Route path="/" element={<Navigate to="/GeneralHome" />} />
          <Route path="/GeneralHome" element={<GeneralHome />} />
          <Route path="/home" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/control" element={<Control />} />
          <Route path="/settings" element={<BoardUser />} />
          <Route path="/alexaprivacy" element={<AlexaPrivacyPolicy />} />
          <Route path="/mod" element={<BoardModerator />} />
          <Route path="/admin" element={<BoardAdmin />} />
          <Route path="*" element={<GeneralHome />} /> {/* Default */}
        </Routes>
      </div>

      {/* <AuthVerify logOut={logOut}/> */}
    </div>
  );
};

export default App;
